import LoginApi from '../login/LoginApi.js';

export const DASHBOARD_URL = '/users/dashboard/';
const POSTREGISTRATION_URL = '/users/postregistration/';

/**
 * Lands a freshly authenticated visitor. `registration_incomplete` fires only on
 * the first PROTECTED call, never on `/login` or `/oauth` themselves, so one
 * profile probe decides the destination, and that gate always beats `redirectTo`.
 * Never rejects: the login itself already succeeded.
 *
 * @param {string} accessToken
 * @param {string} redirectTo
 */
export async function landAfterAuth(accessToken, redirectTo) {
	try {
		await LoginApi.getProfile(accessToken);
		window.location.assign(redirectTo);
	} catch (err) {
		const code = err?.response?.data?.data?.code;
		const nextPath = err?.response?.data?.data?.nextPath;
		if (err?.response?.status === 409 && code === 'registration_incomplete') {
			window.location.assign(nextPath || POSTREGISTRATION_URL);
			return;
		}
		window.location.assign(redirectTo);
	}
}

/**
 * Exchanges a provider id_token for a session, then lands the visitor. API
 * errors reject untouched, for the caller to render with `parseLoginError`.
 *
 * @param {'google'|'microsoft'} provider
 * @param {string} idToken
 * @param {{redirectTo?: string}} [options]
 */
export async function completeOAuthSignIn(provider, idToken, { redirectTo = DASHBOARD_URL } = {}) {
	const { data } = await LoginApi.oauthLogin(provider, idToken);
	await landAfterAuth(data?.data?.accessToken, redirectTo);
}
